import { createLogger } from "../../utils";
import allSettled from "../../utils/all-settled";
const logger = createLogger("geoV1");
const GEO_READY_EVENT = "ALMAGEO_LOCATION";
const PERMISSIONS = ["ADS"];
async function accessGeoClientV1(timeout, cache, method) {
    return new Promise((resolve, reject) => {
        const geoTimeout = setTimeout(() => reject(new Error("Geo timeout")), timeout);
        try {
            const geoHandler = () => {
                logger.logInfo(`Got GEO ready event`);
                window.document.removeEventListener(GEO_READY_EVENT, geoHandler, false);
                clearTimeout(geoTimeout);
                const result = window.ALMA.geo[method](PERMISSIONS, {
                    timeout,
                    cache,
                });
                logger.logInfo(`Resolved ${method}: ${JSON.stringify(result, null, 2)}`);
                resolve(result);
            };
            if (typeof window?.ALMA?.geo?.[method] === "function") {
                logger.logInfo(`Call ${method}`);
                const result = window.ALMA.geo[method](PERMISSIONS, {
                    timeout,
                    cache,
                });
                logger.logInfo(`Resolved ${method}: ${JSON.stringify(result, null, 2)}`);
                if (!(result instanceof Error)) {
                    clearTimeout(geoTimeout);
                    resolve(result);
                }
                else {
                    logger.logInfo(`Geo returned error ${result}`);
                    if (result.message === "WAITING_BROWSER_GEOLOCATION") {
                        logger.logInfo(`Geo is not ready, add listener`);
                        window.document.addEventListener(GEO_READY_EVENT, geoHandler, false);
                    }
                    else {
                        logger.logInfo(`Geo error '${result.message}' unrecoverable, reject`);
                        reject(result);
                    }
                }
            }
            else {
                logger.logInfo(`Geo is not ready, add listener`);
                window.document.addEventListener(GEO_READY_EVENT, geoHandler, false);
            }
        }
        catch (e) {
            logger.logError("caught error", e);
            reject(new Error(e));
        }
    });
}
async function getLocationCoordinates(timeout = 1000, cache = true) {
    logger.logInfo(`coordinates requested, trying GeoV1`);
    return accessGeoClientV1(timeout, cache, "getCoordinates");
}
async function getLocationApproximation(timeout = 1000, cache = true) {
    logger.logInfo(`approximation requested, trying GeoV1`);
    return accessGeoClientV1(timeout, cache, "getApproximation");
}
async function getLocationV1(timeout = 1000, cache = true) {
    const locResults = await allSettled([
        getLocationCoordinates(timeout, true),
        getLocationApproximation(timeout, true),
    ]);
    const geoObject = {
        meta: { resolvedAt: Date(), fromCache: cache },
        coordinates: locResults[0].status === "fulfilled" ? locResults[0].value : undefined,
        approximation: locResults[1].status === "fulfilled" ? locResults[1].value : undefined,
    };
    return geoObject;
}
export default getLocationV1;
//# sourceMappingURL=geo-v1.js.map